import { FeedDisplayType, FeedItemModel } from "outbound-api-client/lib/models";
import { apiService } from "../../services";
import i18n from "i18next";


export const getFeedItems = async (feedDisplayType: FeedDisplayType): Promise<FeedItemModel[]> => {
  return apiService.instance.getFeedItems(i18n.language, feedDisplayType);
  // return apiService.instance.getFeedItems("*", feedDisplayType);
}

// export const getFeedItem = async (id: string): Promise<FeedItemModel> => {
//   return apiService.instance.getFeedItem("*", "*", id);
// }
